import { Flex, type FlexProps, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBetaBadgeStyles } from '~/components/shared/componentStyles/BetaBadge.style'

export const BetaBadge = (props: FlexProps) => {
  const { t } = useTranslation()
  const styles = useBetaBadgeStyles()
  return (
    <Flex css={styles.container} {...props}>
      <Flex css={styles.contentContainer}>
        <Text css={styles.text}>{t('experimentsState.badge.beta')}</Text>
      </Flex>
    </Flex>
  )
}
